export default "__VITE_ASSET__QYGKAFMZ__"